import { Address } from "@/types";
import { makeAddress, reduceString } from "@/utils";
import classNames from "classnames";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FaCopy } from "react-icons/fa";
import "./style.scss";

interface Props {
  address: Address;
  className?: string;
}

export const TargetAddress = ({ address, className }: Props) => {
  const network = address.network.split("-")[0]; // for "Mainnet-beta", cut off "beta" for compactness
  const explorerURL = makeAddress(
    address.chain,
    address.network,
    address.address,
  );
  const label = address.alias
    ? address.alias
    : reduceString(address.address, 5);
  return (
    <div className={classNames("target-address", className)}>
      <span className="target-address__network me-2">
        <div>{address.chain}</div>
        <div>{network}</div>
      </span>
      {explorerURL ? (
        <a href={explorerURL} target="_blank" rel="noreferrer">
          <span>{label}</span>
        </a>
      ) : (
        <span>{label}</span>
      )}

      <CopyToClipboard text={address.address}>
        <FaCopy
          style={{ cursor: "pointer" }}
          title="Copy address to clipboard"
          className="ms-1 my-auto"
          size={12}
          color="#717171"
        />
      </CopyToClipboard>
    </div>
  );
};
